import { CrearLlamadoRequest, Llamado, LlamadoListado } from '../models/Entities/Turnero';
import { apiRequest, buildURL } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'offices/Llamados';

export const CrearLlamado = async (token: string, payload: CrearLlamadoRequest): Promise<Llamado> => {
    return apiRequest<Llamado>(BaseURL, token, 'CrearLlamado', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const GetUltimosLlamadosPorSector = async (token: string, sectorId: number): Promise<LlamadoListado[]> => {
    const requestURL = buildURL(BaseURL, 'ultimos', sectorId);
    return apiRequest<LlamadoListado[]>(requestURL, token, 'GetUltimosLlamadosPorSector');
};

export const PurgeOldLlamados = async (token: string): Promise<number> => {
    const requestURL = buildURL(BaseURL, 'purge-old');
    return apiRequest<number>(requestURL, token, 'PurgeOldLlamados', {
        method: 'POST'
    });
};
